import { render, staticRenderFns } from "./NotAvailable.vue?vue&type=template&id=98a4dca8&scoped=true&"
import script from "./NotAvailable.vue?vue&type=script&lang=js&"
export * from "./NotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./NotAvailable.vue?vue&type=style&index=0&id=98a4dca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a4dca8",
  null
  
)

export default component.exports